module.exports = __webpack_public_path__ + "img/c04_unittechspearmanchampion_Normal_ua.669a5d7e.webp";